import { Pipe, PipeTransform } from '@angular/core';
import { SanitizeChar } from 'app/shared/util/sanitize-char';

@Pipe({
  name: 'filterArray'
})
export class FilterArrayPipe implements PipeTransform {

  constructor(
    private sanitizeChar: SanitizeChar) { }

  transform(value: any[], args: string = ""): any {
    if (args && args.length && value)
      return value.filter(item => this.sanitizeChar.convert(item.toLocaleLowerCase()).indexOf(this.sanitizeChar.convert(args.toLocaleLowerCase())) > -1);
    else
      return value;
  }

}
